export default __webpack_public_path__ + "static/media/anime3.4438e506.png";